import { ApiText } from './api-text';

export class Provider {
	code: string;
	text: ApiText;

    constructor()
	constructor(code?: string, description?: string) {
		this.code = code;
		this.text = new ApiText("", "", "", description);
	}

    get display(): string {
        return `${this.code}`;
    }

    static fromObject(object: Provider): Provider {
        return Object.assign(new Provider(), object);
    }

    doesInclude(value: string): boolean {
        return this.some([this.code], value);
    }

    protected some(props: string[], value: string): boolean {
        return props.some(prop => prop.toLowerCase().includes(value));
    }
}
